// /* eslint-disable react-hooks/exhaustive-deps */
// import "./App.css";
// import { PageRouting } from "./PageRouting";
// import "antd/dist/reset.css";
// import { ConfigProvider, message } from "antd";
// import { VoiceCommandProvider } from "./Components/Pages/VoiceCommand/VoiceContext";
// import { useDispatch, useSelector } from "react-redux";
// import { useEffect, useState, useRef } from "react";
// import { db, onForegroundMessage } from "./config/firebase";
// import IncomingCallModal from "./Components/Shared/IncomingCallModal";
// import { collection, query, where, onSnapshot, updateDoc, serverTimestamp } from "firebase/firestore";
// import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
// import { APP_ROUTES } from "./PageRouting/approutes";
// import AppointmentService from "./Services/AppointmentService";
// import { deleteDoc, doc } from "firebase/firestore";
// import PatientService from "./Services/PatientService";
// import ConsultationService from "./Services/ConsultationService";
// import CommonFunctions from "./Components/Shared/CommonFunctions";
// import { getLoaderState } from "./Redux/actions/CommonActions";
// import { clearLoggedUser, clearSelectedAppt, saveLoggedUser, setSelectedAppt } from "./Redux/actions/UserActions";

// function App() {
//   const [incomingData, setIncomingData] = useState([]);
//   const history = useHistory();
//   const loader = useSelector((state) => state.common.loader);
//   const dispatch = useDispatch();
//   const { loggedUser, selectedAppt } = useSelector((state) => state.user);
//   const idleTimerRef = useRef(null);
//   const handleIdle = () => {
//     sessionStorage.clear();
//     sessionStorage.clear();
//     if ("caches" in window) {
//       caches.keys().then(names => {
//         for (let name of names) {
//           caches.delete(name);
//         }
//       });
//     }
//     dispatch(clearLoggedUser(null));
//     dispatch(clearSelectedAppt(null));
//     history.push(APP_ROUTES.LOGINFORM);
//   };

//   useEffect(() => {
//     const resetTimer = () => {
//       if (idleTimerRef.current) clearTimeout(idleTimerRef.current);
//       idleTimerRef.current = setTimeout(handleIdle, 7200000);
//     };
//     const events = ["mousemove", "keydown", "scroll", "click"];
//     events.forEach(event => window.addEventListener(event, resetTimer));
//     resetTimer();
//     return () => {
//       events.forEach(event =>
//         window.removeEventListener(event, resetTimer)
//       );
//       if (idleTimerRef.current) clearTimeout(idleTimerRef.current);
//     };
//   }, []);

//   useEffect(() => {
//     if (!loggedUser) {
//       const loggedUserObj = sessionStorage.getItem("login_result");
//       const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;
//       dispatch(saveLoggedUser(loggedUser));
//     }
//   }, [loggedUser]);

//   useEffect(() => {
//     const doctorId = loggedUser?.user?.userId;
//     if (!doctorId) return;

//     const callsRef = collection(db, "calls");

//     const q = query(
//       callsRef,
//       where("incomingCall.receiverId", "==", doctorId),
//       where("incomingCall.status", "==", 1)
//     );

//     const unsubscribe = onSnapshot(q, (snapshot) => {
//       if (snapshot.empty) {
//         sessionStorage.removeItem("incoming");
//         sessionStorage.removeItem("incomingModal");
//         setIncomingData([]);
//         return;
//       }
//       const calls = snapshot.docs.map(doc => ({
//         id: doc.id,
//         ...doc.data()
//       }));

//       setIncomingData(calls);
//       sessionStorage.setItem("incoming", JSON.stringify(calls));
//       sessionStorage.setItem("incomingModal", "true");
//     });

//     return () => unsubscribe();
//   }, [loggedUser?.user?.userId, selectedAppt]);

//   const handleAcceptCall = async (roomId) => {
//     if (!roomId) return;
//     dispatch(getLoaderState(true));
//     await updateDoc(doc(db, "calls", roomId), {
//       "incomingCall.status": 2, // in call
//       "incomingCall.acceptedAt": serverTimestamp()
//     });


//     const roomObj = incomingData?.find((item) => item.incomingCall.roomId === roomId)?.incomingCall;
//     sessionStorage.setItem("callRoomId", roomObj.roomId);

//     // Clear record from firebase
//     // await deleteFirebaseCallRecord(callerId);

//     // Navigate to call

//     try {
//       let payload = {
//         patientId: roomObj.callerId,
//       };

//       const patRes = await PatientService.PatientListFilter(payload);
//       sessionStorage.setItem("patient", JSON.stringify(patRes.data[0]));

//       let apptPayload = {
//         appointmentId: roomObj.roomId,
//       };

//       let apptObj = await AppointmentService.AppointmentFilter(apptPayload);
//       const record = apptObj.data[0];
//       dispatch(setSelectedAppt(record));
//       sessionStorage.setItem("selectedAppt", JSON.stringify(record));
//       let queuePayload = {
//         appointmentId: roomObj.roomId,
//         modifiedBy: record.userId,
//         modifiedDate: CommonFunctions.convertUTCDate(
//           new Date(),
//           "YYYY-MM-DD HH:mm:ss"
//         ),
//         patientId: record.patientId,
//         startDateTime: CommonFunctions.convertUTCDate(
//           new Date(),
//           "YYYY-MM-DD HH:mm:ss"
//         ),
//         userId: record.userId,
//         userName: record?.userName,
//         personType: "Doctor",
//       };
//       await ConsultationService.updateStartTime(queuePayload);
//       // Clear popup
//       const updatedState = incomingData?.filter(item => item.incomingCall.roomId !== roomId) || [];
//       if (updatedState?.length === 0) {
//         sessionStorage.removeItem("incoming");
//         sessionStorage.removeItem("incomingModal");
//       }
//       else {
//         sessionStorage.setItem("incoming", JSON.stringify(updatedState));
//       }
//       setIncomingData((prevState) => prevState?.filter(item => item.incomingCall.roomId !== roomId));
//       history.push(APP_ROUTES.VIDEOCALL, { selectedPatient: record });
//       window.scrollTo(0, 0);
//     } catch (error) {
//       console.error(error);
//       message.error("An error occured try again");
//     } finally {
//       dispatch(getLoaderState(false));
//     }



//   };

//   const handleRejectCall = async (roomId) => {
//     if (!roomId) return;
//     // await deleteFirebaseCallRecord(callerId);
//     await updateDoc(doc(db, "calls", roomId), {
//       "incomingCall.status": -1,
//       "incomingCall.endedAt": serverTimestamp()
//     });

//     const updatedState = incomingData?.filter(item => item.incomingCall.roomId !== roomId) || [];
//     if (updatedState?.length === 0) {
//       sessionStorage.removeItem("incoming");
//       sessionStorage.removeItem("incomingModal");
//     }
//     else {
//       sessionStorage.setItem("incoming", JSON.stringify(updatedState));
//     }

//   };

//   const deleteFirebaseCallRecord = async (callerId) => {
//     if (!callerId) return;

//     try {
//       await deleteDoc(doc(db, "calls", callerId));
//       setIncomingData(prev =>
//         prev.filter(item => item.incomingCall.callerId !== callerId)
//       );
//     }
//     catch (e) {
//       console.error(e);
//     }
//   }


//   return (
//     <>
//       <VoiceCommandProvider>
//         <ConfigProvider
//           theme={{
//             token: {
//               colorPrimary: "#1D64C8",
//             },
//             components: {
//               Segmented: {
//                 itemSelectedBg: "#1D64C8",
//               },
//             },
//           }}
//         >
//           {loader && (
//             <div class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
//               <div className="spinner"></div>
//             </div>
//           )}
//           <PageRouting />
//           <IncomingCallModal
//             data={incomingData}
//             onAccept={handleAcceptCall}
//             onReject={handleRejectCall}
//             setIncomingData={setIncomingData}
//           />
//         </ConfigProvider>
//       </VoiceCommandProvider>

//     </>
//   );
// }

// export default App;

// ─────────────────────────────────────────────────────────────────────────────
// DOCTOR APP — App.js
// ─────────────────────────────────────────────────────────────────────────────
/* eslint-disable react-hooks/exhaustive-deps */
import "./App.css";
import { PageRouting } from "./PageRouting";
import "antd/dist/reset.css";
import { ConfigProvider, message, notification } from "antd";
import { VoiceCommandProvider } from "./Components/Pages/VoiceCommand/VoiceContext";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useRef, useCallback } from "react";
import { db, listenDietImageUploads, markDietNotificationSeen } from "./config/firebase";
import { CALL_STATUS, deleteCallRecord } from "./config/firebase";
import IncomingCallModal from "./Components/Shared/IncomingCallModal";
import DietNotificationModal from "./Components/Shared/DietNotificationModal";
import {
  collection,
  query,
  where,
  onSnapshot,
  updateDoc,
  serverTimestamp,
  doc,
} from "firebase/firestore";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { APP_ROUTES } from "./PageRouting/approutes";
import AppointmentService from "./Services/AppointmentService";
import PatientService from "./Services/PatientService";
import ConsultationService from "./Services/ConsultationService";
import CommonFunctions from "./Components/Shared/CommonFunctions";
import { getLoaderState } from "./Redux/actions/CommonActions";
import {
  clearLoggedUser,
  clearSelectedAppt,
  saveLoggedUser,
  setSelectedAppt,
} from "./Redux/actions/UserActions";

function App() {
  const [incomingData, setIncomingData] = useState([]);
  const [dietNotifications, setDietNotifications] = useState([]);
  const history = useHistory();
  const loader = useSelector((state) => state.common.loader);
  const dispatch = useDispatch();
  const { loggedUser, selectedAppt } = useSelector((state) => state.user);
  const idleTimerRef = useRef(null);

  // ─── Idle-logout timer ─────────────────────────────────────────────────────
  const handleIdle = useCallback(() => {
    sessionStorage.clear();
    sessionStorage.clear();
    if ("caches" in window) {
      caches.keys().then((names) => names.forEach((n) => caches.delete(n)));
    }
    dispatch(clearLoggedUser(null));
    dispatch(clearSelectedAppt(null));
    history.push(APP_ROUTES.LOGINFORM);
  }, [dispatch, history]);

  useEffect(() => {
    const resetTimer = () => {
      if (idleTimerRef.current) clearTimeout(idleTimerRef.current);
      idleTimerRef.current = setTimeout(handleIdle, 7_200_000); // 2 hours
    };
    const events = ["mousemove", "keydown", "scroll", "click"];
    events.forEach((e) => window.addEventListener(e, resetTimer));
    resetTimer();
    return () => {
      events.forEach((e) => window.removeEventListener(e, resetTimer));
      if (idleTimerRef.current) clearTimeout(idleTimerRef.current);
    };
  }, [handleIdle]);

  // ─── Rehydrate logged user from sessionStorage ───────────────────────────────
  useEffect(() => {
    if (!loggedUser) {
      const raw = sessionStorage.getItem("login_result");
      const parsed = raw ? JSON.parse(raw) : null;
      dispatch(saveLoggedUser(parsed));
    }
  }, [loggedUser]);

  // ─── Listen for incoming call notifications (doctor is the RECEIVER) ────────
  // FIX: removed `selectedAppt` from deps — no need to re-subscribe when the
  // selected appointment changes; the snapshot filter in IncomingCallModal
  // handles hiding the notification if the doctor is already in that room.
  useEffect(() => {
    const doctorId = loggedUser?.user?.userId;
    if (!doctorId) return;

    const q = query(
      collection(db, "calls"),
      where("incomingCall.receiverId", "==", doctorId),
      where("incomingCall.status", "==", CALL_STATUS.RINGING)
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      if (snapshot.empty) {
        setIncomingData([]);
        return;
      }
      const calls = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
      setIncomingData(calls);
    });

    return () => unsubscribe();
  }, [loggedUser?.user?.userId]); // ← only re-subscribe when the user changes

  useEffect(() => {
    if (!loggedUser?.user?.userId) return;

    const unsub = listenDietImageUploads(loggedUser?.user?.userId, (docId, data) => {
      setDietNotifications(prev => [
        { 
          id: docId, 
          ...data,
          createdAt: data.createdAt || { seconds: Date.now() / 1000 } 
        },
        ...prev
      ]);
      
      // Mark as seen in Firestore so it doesn't re-fire from other tabs
      markDietNotificationSeen(docId);
    });

    return () => unsub();
  }, [loggedUser?.user?.userId]);

  const handleCloseDietNotification = useCallback((id) => {
    setDietNotifications(prev => prev.filter(n => n.id !== id));
  }, []);

  // ─── Accept call ─────────────────────────────────────────────────────────
  const handleAcceptCall = useCallback(
    async (roomId) => {
      if (!roomId) return;
      dispatch(getLoaderState(true));

      try {
        // Mark call as "in-call" so the caller's side knows the receiver joined
        await updateDoc(doc(db, "calls", roomId), {
          "incomingCall.status": CALL_STATUS.IN_CALL,
          "incomingCall.acceptedAt": serverTimestamp(),
        });

        const roomObj = incomingData?.find(
          (item) => item.incomingCall.roomId === roomId
        )?.incomingCall;

        sessionStorage.setItem("callRoomId", roomObj.roomId);

        // Fetch patient and appointment details
        const patRes = await PatientService.PatientListFilter({
          patientId: roomObj.callerId,
        });
        sessionStorage.setItem("patient", JSON.stringify(patRes.data[0]));

        const apptObj = await AppointmentService.AppointmentFilter({
          appointmentId: roomObj.roomId,
        });
        const record = apptObj.data[0];
        dispatch(setSelectedAppt(record));
        sessionStorage.setItem("selectedAppt", JSON.stringify(record));

        await ConsultationService.updateStartTime({
          appointmentId: roomObj.roomId,
          modifiedBy: record.userId,
          modifiedDate: CommonFunctions.convertUTCDate(
            new Date(),
            "YYYY-MM-DD HH:mm:ss"
          ),
          patientId: record.patientId,
          startDateTime: CommonFunctions.convertUTCDate(
            new Date(),
            "YYYY-MM-DD HH:mm:ss"
          ),
          userId: record.userId,
          userName: record?.userName,
          personType: "Doctor",
        });

        // Dismiss modal locally (Firestore status update will also trigger
        // the snapshot listener to drop this call from state, but we update
        // immediately for instant UI feedback)
        setIncomingData((prev) =>
          prev.filter((item) => item.incomingCall.roomId !== roomId)
        );

        history.push(APP_ROUTES.VIDEOCALL, { selectedPatient: record });
        window.scrollTo(0, 0);
      } catch (error) {
        console.error(error);
        message.error("An error occurred, please try again.");
      } finally {
        dispatch(getLoaderState(false));
      }
    },
    [incomingData, dispatch, history]
  );

  // ─── Reject call ─────────────────────────────────────────────────────────
  // FIX: also clears local state immediately so the modal dismisses at once
  // without waiting for the Firestore snapshot to propagate.
  const handleRejectCall = useCallback(
    async (roomId) => {
      if (!roomId) return;

      // Optimistic local dismissal
      setIncomingData((prev) =>
        prev.filter((item) => item.incomingCall.roomId !== roomId)
      );

      try {
        await updateDoc(doc(db, "calls", roomId), {
          "incomingCall.status": CALL_STATUS.REJECTED,
          "incomingCall.endedAt": serverTimestamp(),
        });
        // The Firestore snapshot query (status == RINGING) will no longer
        // include this doc, so the state stays clean.
      } catch (err) {
        console.error("handleRejectCall error:", err);
        // Re-fetch state from Firestore if the update failed
      }
    },
    []
  );

  return (
    <>
      <VoiceCommandProvider>
        <ConfigProvider
          theme={{
            token: { colorPrimary: "#1D64C8" },
            components: { Segmented: { itemSelectedBg: "#1D64C8" } },
          }}
        >
          {loader && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
              <div className="spinner" />
            </div>
          )}
          <PageRouting />
          <IncomingCallModal
            data={incomingData}
            onAccept={handleAcceptCall}
            onReject={handleRejectCall}
          />
          <DietNotificationModal
            notifications={dietNotifications}
            onClose={handleCloseDietNotification}
          />
        </ConfigProvider>
      </VoiceCommandProvider>
    </>
  );
}

export default App;
